import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/poppins'; // Defaults to 400 (normal weight)
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, useThemeContext } from './context/ThemeContext';


// const addFont = () => {
//   const link = document.createElement('link');
//   link.rel = 'stylesheet';
//   document.head.appendChild(link);
// };

// addFont();

const getAppTheme = (mode) =>
  createTheme({
    palette: {
      mode:
        mode === 'system'
          ? window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
          : mode,
    },
    typography: {
      fontFamily: 'Poppins, sans-serif',
    },
  });

const AppWithTheme = () => {
  const { themeMode } = useThemeContext();

  const theme = useMemo(() => getAppTheme(themeMode), [themeMode]);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MUIThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  // </React.StrictMode>
);

reportWebVitals();